import { CssBaseline, createTheme, ThemeProvider } from "@mui/material"
import { ptBR } from "@mui/material/locale"
import { ReactNode } from "react"

import Overrides from "./overrides"
import palette from "./palette"
import shadows from "./shadows"

interface Props {
  children: ReactNode
}

const MuiThemeProvider = ({ children }: Props) => {
  const theme = createTheme(
    {
      palette,
      shadows,
    },

    ptBR,
  )
  theme.components = Overrides(theme)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export default MuiThemeProvider
